<template>
  <md-card class="dialog-card">
    <md-card-content style="margin: 0; padding: 5px 10px">
      <tabs
        :options="tabsOptions"
        :cacheLifetime="0"
        id="evidences-tabs"
        class="md-layout-item md-size-100"
        ref="tabs"
        @changed="tabChanged"
      >
        <tab
          v-for="fileType in fileTypes"
          :id="fileType.id"
          :name="fileType.name"
          :key="fileType.id"
        >
          <md-button
            v-if="editMode && canAddFile"
            :disabled="fileType.disableCharge(files) || loading"
            @click="fileAction(fileType)"
            class="md-simple"
            :class="!fileType.disableCharge(files) ? 'md-info' : ''"
          >
            Cargar archivo/s
            <md-tooltip v-if="fileType.allowedFormats">
              <strong>Formatos permitidos:</strong>
              <p>{{ fileType.allowedFormats.toString() }}</p>
            </md-tooltip>
            <md-icon class="md-primary">file_present</md-icon>
          </md-button>
          <div
            v-if="fileType.type === 'image' && canViewFile"
            class="file-matrix"
          >
            <Matrix :images="files[fileType.codename]">
              <template
                slot="image-actions"
                slot-scope="{ isVisible, image: photo, index }"
              >
                <template v-if="photo.id">
                  <md-button
                    class="md-just-icon md-round md-info view"
                    @click="$emit('openVisor', photo)"
                  >
                    <md-icon>remove_red_eye</md-icon>
                    <md-tooltip>Ver archivo</md-tooltip>
                  </md-button>
                  <md-button
                    @click.stop="mapVisible[photo.id] = !mapVisible[photo.id]"
                    class="md-just-icon md-round visible"
                    :disabled="!canAddFile || mapReject[photo.id] || !editMode"
                    :style="!photo.visibleCustomer ? 'opacity: 0.85;' : ''"
                    :class="{
                      'md-plain': !mapVisible[photo.id],
                      'md-primary': mapVisible[photo.id],
                    }"
                  >
                    <md-icon>people_alt</md-icon>
                    <md-tooltip class="md-primary">
                      <template v-if="!photo.clientVisibility">
                        Presione el boton para hacer el archivo visible para el
                        cliente
                      </template>
                      <template v-else
                        >El archivo es visible por el cliente.</template
                      >
                    </md-tooltip>
                  </md-button>
                  <md-button
                    v-if="canDeleteFile && editMode"
                    @click.stop="mapReject[photo.id] = !mapReject[photo.id]"
                    class="md-just-icon md-round reject"
                    :class="{
                      'md-danger': mapReject[photo.id],
                      'md-secondary': !mapReject[photo.id],
                    }"
                  >
                    <md-icon>close</md-icon>
                    <md-tooltip class="md-primary"
                      >Presione el boton para rechazar la foto</md-tooltip
                    >
                  </md-button>
                </template>
                <template v-else>
                  <md-button
                    @click.stop="removeFile(fileType, index)"
                    class="md-just-icon md-round md-danger"
                  >
                    <md-icon>delete</md-icon>
                    <md-tooltip class="md-primary"
                      >Remover el archivo</md-tooltip
                    >
                  </md-button>
                </template>
              </template>
            </Matrix>
            <loading-content
              v-if="
                !files[fileType.codename] || !files[fileType.codename].length
              "
              slot="empty-state"
              class="md-accent"
              empty-icon="photo_library"
              :empty-label="`Sin archivos de ${fileType.name}`"
              empty-description="No se han subido archivos."
            />
          </div>
          <div
            v-else-if="fileType.type !== 'image' && canViewFile"
            class="file-container file-matrix"
          >
            <md-card
              v-for="(file, index) of files[fileType.codename]"
              :key="index"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-80">
                  <md-icon class="md-primary md-size-2x"
                    >picture_as_pdf</md-icon
                  >
                  <md-tooltip>{{ file.name || file.file.name }}</md-tooltip>
                </div>
                <div class="md-layout-item md-size-20">
                  <div v-if="file.id" class="buttons">
                    <md-button
                      class="md-info md-just-icon md-round"
                      @click="showFile(file)"
                    >
                      <md-icon>remove_red_eye</md-icon>
                      <md-tooltip>Ver archivo</md-tooltip>
                    </md-button>
                    <md-button
                      @click.stop="mapVisible[file.id] = !mapVisible[file.id]"
                      class="md-just-icon md-round"
                      :disabled="
                        !canChangeFile || mapReject[file.id] || !editMode
                      "
                      :style="!file.visibleCustomer ? 'opacity: 0.85;' : ''"
                      :class="{
                        'md-plain': !mapVisible[file.id],
                        'md-primary': mapVisible[file.id],
                      }"
                    >
                      <md-icon>people_alt</md-icon>
                      <md-tooltip class="md-primary">
                        <template v-if="!file.clientVisibility">
                          Presione el boton para hacer el archivo visible para
                          el cliente
                        </template>
                        <template v-else
                          >El archivo es visible por el cliente.</template
                        >
                      </md-tooltip>
                    </md-button>
                    <md-button
                      v-if="canDeleteFile && editMode"
                      class="md-just-icon md-round"
                      :class="!!mapReject[file.id] ? 'md-danger' : ''"
                      @click="mapReject[file.id] = !mapReject[file.id]"
                    >
                      <md-icon>close</md-icon>
                      <md-tooltip>Rechazar archivo</md-tooltip>
                    </md-button>
                  </div>
                  <div v-else class="buttons">
                    <md-button
                      @click="removeFile(fileType, index)"
                      class="md-just-icon md-primary md-simple"
                    >
                      <md-icon class="md-primary">delete</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
              <p class="date-text md-caption" v-if="file.id">
                Subido el:
                <strong>{{ file.addDate | shortDate }}</strong>
              </p>
            </md-card>
            <loading-content
              v-if="
                !files[fileType.codename] || !files[fileType.codename].length
              "
              slot="empty-state"
              class="md-accent"
              empty-icon="picture_as_pdf"
              :empty-label="`Sin archivos de ${fileType.name}`"
              empty-description="No se han subido archivos."
            />
          </div>
        </tab>
      </tabs>
    </md-card-content>
  </md-card>
</template>

<script>
import Matrix from "./Matrix";

import { cloneDeep } from "lodash";
import { mapPermissions } from "@/plugins/accountPermissions/";

export default {
  name: "FilesTab",
  components: { Matrix },
  props: {
    fileTypes: {
      type: Array,
      required: true,
      default: () => [],
    },
    loadedFiles: {
      type: Object,
      required: true,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentType: null,
      loading: false,
      files: {},
      mapReject: {},
      mapVisible: {},
      currentTab: null,
    };
  },
  computed: {
    ...mapPermissions("WorkPlan", "photoreason"),
    ...mapPermissions("Commons", "file"),
    tabsOptions() {
      return {
        useUrlFragment: false,
        defaultTabHash: this.currentTab,
      };
    },
  },
  methods: {
    showFile({ file }) {
      if (file) {
        const win = window.open(file, "_blank");
        win.focus();
      }
    },
    tabChanged({ tab }) {
      const tId = tab.id;
      this.currentTab = tId;
    },
  },
  watch: {
    loadedFiles: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.files = cloneDeep(newVal);
        }
      },
    },
    fileTypes(value) {
      if (value && value[0]) {
        const { codename } = value[0];
        this.currentTab = codename;
        this.$refs.tabs.selectTab(`#${codename}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.md-card-content {
  background-color: white;
}
.file-matrix {
  margin: 0;
  padding-top: 10px;
  padding-bottom: -10px;
}
.dialog-card {
  .md-card-content {
    min-height: 200px;
    background-color: rgb(238, 238, 238);
    padding-bottom: 0;
    .tabs {
      padding: 0;
    }
  }
}
.md-button.md-just-icon {
  height: 25px;
  width: 25px;
  min-width: 25px;
}
.file-container {
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  .md-card {
    width: 150px;
    margin: 0 4px;
    min-height: 90px;
    div {
      height: 100%;
      div {
        height: 100%;
        display: flex;
        .buttons {
          flex-direction: column;
        }
      }
    }
    .date-text {
      margin-top: 10px;
      text-align: center;
    }
  }
}

.visible {
  bottom: 20px;
}
.reject {
  bottom: -10px;
}
.view {
  bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/FilesTab.vue